// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__95oFY","error__content":"Error_error__content__uTaiq","error__title":"Error_error__title__GAWqo","error__action_bloc":"Error_error__action_bloc__5SDX3"};